import { Divider } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import useTrackComponent from 'hooks/eventTracking/useTrackComponent'
import { ActionType } from 'types/tracking'
import { useFeatureFlag } from 'util/featureFlags'
import { HardwareFilterSidebarMenu } from '../../pages/ordering/catalog/HardwareFilterSidebar'
import { SelectedMenu } from './constant'
import MenuItemLink from './elements/MenuItemLink'
import { SelectedMenuType, SubMenuConfigType } from './type'

const SideBarNavigationSubMenu = ({
  title,
  subMenus,
  activeMenu,
  distributorName,
}: {
  title: string
  subMenus: SubMenuConfigType[]
  activeMenu: SelectedMenuType
  distributorName: string | undefined
}) => {
  const enableMultiDistributorShop = useFeatureFlag('enable_multi_distributor_shop', 'on')
  const { trackUserInteraction } = useTrackComponent({
    componentKey: 'side_bar_navigation_sub_menu',
    eventName: 'Hardware Navigation Button',
  })

  const onClick = (amplitudeEventSource?: string, key?: string) => {
    if (enableMultiDistributorShop) {
      trackUserInteraction(
        { type: ActionType.CLICK },
        {
          source: `lhs_${key}_button`,
          ...(distributorName ? { distributor: distributorName } : {}),
        }
      )
    } else {
      trackUserInteraction(
        { type: ActionType.CLICK },
        { eventName: 'Hardware Sidebar Navigation Sub Menu Button Clicked', source: amplitudeEventSource }
      )
    }
  }

  const hasSubMenu = subMenus.length > 0

  return (
    <>
      <Typography gutterBottom variant="h6">
        {hasSubMenu && title}
      </Typography>
      {subMenus.map((menu: SubMenuConfigType) => (
        <MenuItemLink
          key={menu.title}
          title={menu.title}
          id={menu.title}
          url={menu.url}
          exact={true}
          onClick={() => onClick(menu?.amplitudeEventSource, menu.key)}
        />
      ))}
      {hasSubMenu && <Divider style={{ marginTop: '16px' }} />}
      {activeMenu === SelectedMenu.BUY_HARDWARE && <HardwareFilterSidebarMenu />}
    </>
  )
}

export default SideBarNavigationSubMenu
